
import { QuestionCircleOutlined, SortDescendingOutlined, SortAscendingOutlined, } from '@ant-design/icons'; import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Button, Input, Pagination, Popconfirm, message } from 'antd';
import { useBeaconList, useDeleteBeacon, useStatusTag } from "hooks/configuration/tag/tag";
import { PAGES, ACTIONS, usePermissions } from 'hooks/permissions/permissions';
import StatusBadge from 'components/statusBadge';
import { Link } from 'react-router-dom';
import { statusColor, PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";
import Image from 'helpers/Image';
import "../style.css";
import TableStateRow from "components/tableState";

const Becon = () => {

    const { can } = usePermissions();
    const canAdd = can(PAGES.RFID_CARD, ACTIONS.ADD);
    const canEdit = can(PAGES.RFID_CARD, ACTIONS.EDIT);
    const canDelete = can(PAGES.RFID_CARD, ACTIONS.DELETE);
    const showActions = canEdit || canDelete;
    const columnCount = showActions ? 3 : 2;

    const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
    const [listData, setListData] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchKey, setSearchKey] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
    const [defaultCall, setDefaultCall] = useState(false);

    const [sorting, setSorting] = useState({
        "ts.card_id": null,
        "ts.active": null,
    });

    const [initValues, setInitValues] = useState({
        "pageNumber": pageNumber,
        "pageSize": page,
        "searchKey": searchKey
    });

    const { mutate: getBeaconList, data: beaconListData, isLoading: Loading } = useBeaconList();
    const { mutate: deleteBeacon, isLoading: deleteLoading } = useDeleteBeacon();
    const { mutate: statusChange } = useStatusTag();

    const deleteId = (id) => {
        deleteBeacon(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.data);
                    onFetchBeaconList(initValues);
                }
                else {
                    message.error(item?.data);
                }
            },
        });
    }

    const onFetchBeaconList = (values) => {
        getBeaconList(values, {
            onSuccess: (item) => {
                setListData(item?.data?.content);
            }
        })
    }

    const handleConfirmActive = (id) => {
        statusChange(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchBeaconList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }

    const onChange = (page) => {
        initValues.pageNumber = page - 1;
        setInitValues(initValues);
        setPageNumber(page - 1);
    }

    const onSortChange = async (column) => {
        initValues.pageNumber = 0;
        initValues.sortField = column;
        initValues.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPageNumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitValues(initValues);
        setSortField(column);
        setSortMethod(newSorting[column]);
        setListData([]);
    };

    const onShowSizeChange = (current, pageSize) => {
        setPage(initValues.pageSize = pageSize)
    }

    const onSearchHandler = (e) => {
        initValues.searchKey = e.target.value;
        let data = { ...initValues };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initValues.pageNumber;
        e.target.value !== "" ? data.pageNumber = 0 : data.pageNumber = pageNumber;
        setInitValues(data);
        setSearchKey(e.target.value);
    }

     useEffect(() => {
            setDefaultCall(true);
        }, [])

    useEffect(() => {
        if (defaultCall) {
        onFetchBeaconList(initValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCall,pageNumber, searchKey, page, sortField, sortMethod]);

    return (
        <Fragment>
            <div className="common-head">
                <div className="title">
                    <h1>RFID Cards</h1>
                    <p>Cards issued to employees, and which are still unassigned</p>
                </div>
                <div className="txt-right single-line">
                    <Input placeholder='Search' onChange={onSearchHandler} prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
                    {!canAdd ? null : <Link to="/configuration/tag/create">
                        <Button><Image name="plus.png" /> New Tag</Button>
                    </Link>}
                </div>
            </div>
            <div className="common-table">
                <table>
                    <thead>
                        <tr>
                            <th>Tag/Card ID {sorting["ts.card_id"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("ts.card_id")} /> : <SortDescendingOutlined onClick={() => onSortChange("ts.card_id")} />}</th>
                            <th>Status {sorting["ts.active"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("ts.active")} /> : <SortDescendingOutlined onClick={() => onSortChange("ts.active")} />}</th>
                            {showActions ? <th>Action</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        {Loading ? (
                            <TableStateRow colSpan={columnCount} loading />
                        ) : listData == null || listData === undefined || listData?.length === 0 ? (
                            <TableStateRow colSpan={columnCount}>No RFID cards found</TableStateRow>
                        ) : listData.map((item, a) => (
                                <tr key={a}>
                                    <td>{item?.cardId}</td>
                                    <td>
                                        {canEdit ? <Popconfirm title={`Are you sure you want to ${item?.status === true ? "inactivate" : "activate"} this ${item?.cardId}?`}
                                            onConfirm={() => handleConfirmActive(item.tagId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <button className={statusColor(item.status)}>
                                                {item?.status ? "Active" : "InActive"}
                                            </button>
                                        </Popconfirm> : <StatusBadge active={item?.status} />}
                                    </td>
                                    {showActions ? <td>
                                        {!canEdit ? null : <Link to={`/configuration/tag/${item?.tagId}`} state={item}>
                                            <Image name="edit.png" />
                                        </Link>}
                                        {!canDelete ? null : <Popconfirm
                                            Loading={deleteLoading}
                                            title={`Are you sure to delete ${item?.cardId}?`}
                                            onConfirm={() => deleteId(item?.tagId)}
                                            icon={<QuestionCircleOutlined />}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Image name="delete.png" />
                                        </Popconfirm>}
                                    </td> : null}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <Row className="table-pagination">
                <Col md={12}>
                    <h5>Showing {pageNumber === 0 ? 1 : (beaconListData?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (beaconListData?.data?.pageable?.offset + listData?.length || 0) : (beaconListData?.data?.pageable?.offset + beaconListData?.data?.numberOfElements || 0)} of {beaconListData?.data?.totalElements} entries</h5>
                </Col>
                <Col md={12} className="txt-right">
                    {beaconListData?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={onChange} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={beaconListData?.data?.totalElements} />}
                </Col>
            </Row>
        </Fragment>
    )
}

export default Becon;
